import type { Route } from '../../routes/types';
import { PanelGeneral } from './PanelGeneral';
import { DetalleProfesional, Profesionales } from './Profesionales';
import { DetalleReclamo, Reclamos } from './Reclamos';
import { Resenas } from './Resenas';
import './administracion.css';

const soloAdministracion = { roles: ['administrador' as const], layout: 'panel-admin' as const };

export const routes: Route[] = [
  { path: '/admin', title: 'Panel general', screen: PanelGeneral, ...soloAdministracion },
  { path: '/admin/profesionales', title: 'Profesionales', screen: Profesionales, ...soloAdministracion },
  { path: '/admin/profesional/:id', title: 'Profesional', screen: DetalleProfesional, ...soloAdministracion },
  { path: '/admin/reclamos', title: 'Reclamos', screen: Reclamos, ...soloAdministracion },
  { path: '/admin/reclamo/:id', title: 'Reclamo', screen: DetalleReclamo, ...soloAdministracion },
  { path: '/admin/resenas', title: 'Reseñas', screen: Resenas, ...soloAdministracion },
];
